import { IconFilter, IconPencil, IconPlus, IconTrash } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SquareIconButton } from '../../../../../../components/button'
import { TablePagination, TableStanderd } from '../../../../../../components/table'
import { showErrorToast } from '../../../../../../components/toast'
import { useRESTapi } from '../../../../../../controller/restAPI'
import { partyDef, squareButtonVarient, themeStateDef } from '../../../../../../definitions/definintion'
import { setTopNavText } from '../../../../../../redux/config/configSlice'
import { ModalAddBranch, ModalBranchDetails } from './components/modals'
import MenuSimple from '../../../../../../components/menu'
import { InputStd2, SelectBoxInputBox } from '../../../../../../components/inputs'
import { QuestionModal } from '../../../../../../components/modal'

export function PartyCRUD() {

    const [showAddModal, setShowAddModal] = useState(false)
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [selectedEmploye, setSelectedEmploye] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [updateUi, setUpdateUi] = useState(false)
    const [showFilterModal, setShowFilterModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [deleteId,setDeleteId] = useState(null)
    const api = useRESTapi()

    const searchParamDef = {
        fromDate: 'from_date',
        toDate: 'to_date',
        partyId: partyDef.PartyID,
    }
    const [searchParams, setSearchParams] = useState({
        [searchParamDef.partyId]: '',
        [searchParamDef.fromDate]: '',
        [searchParamDef.toDate]: '',
    })
    const [parties, setParties] = useState([])
    const [rows1, setRow1] = useState([
        // {
        //     id: '1',
        //     data: {
        //         [accountLedgerDef.LedgerName]: 'Abu',
        //         [accountLedgerDef.OpeningBalance]: '10000',
        //         [accountLedgerDef.CreditPeriod]: '12000',
        //         [accountLedgerDef.CreditLimit]: '13000',
        //         [accountLedgerDef.AccountGroupId]: 'sample',
        //         [accountLedgerDef.IsDefault]: 'sample',
        //         [accountLedgerDef.CrOrDr]: 'sample',
        //         [accountLedgerDef.Narration]: 'sample',
        //         [accountLedgerDef.MailingName]: 'sample',
        //         [accountLedgerDef.Address]: 'sample',
        //         [accountLedgerDef.Phone]: 'sample',
        //         [accountLedgerDef.Mobile]: 'sample',
        //         [accountLedgerDef.Email]: 'sample',
        //         [accountLedgerDef.IsActive]: 1,
        //     }
        // },
    ])
    const rebuildUi = () => {
        setUpdateUi(!updateUi)
    }
    const dispatch = useDispatch()

    async function deleteParty() {
        setIsLoading(true)
        try {
            const res = await api.Delete({
                url: `${process.env.REACT_APP_BACKEND_URL}/api/parties/${deleteId}`
            });
            if (res?.data?.success === true) {
                
                rebuildUi();
            } else {
                showErrorToast({
                    message: res?.data?.message || 'Error Deleting party'
                })
            }

        } catch (error) {
            console.log(error)
            showErrorToast({
                message: 'Internal Error !!!',
                showAtTimeOne: true,
                id: 'INTERNAL ERROR'
            })
        }
        setIsLoading(false)
        setShowDeleteModal(false)
        setDeleteId(null)
    }

    useEffect(
        () => {

            const initialLoad = async () => {

                setIsLoading(true)
                try {

                    const res1 = await api.get({
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/parties`
                    })
                    if (res1.data.success === true) {
                        setParties([
                            {
                                name: 'ALL',
                                value: null,
                            },
                            ...res1.data.data.map(items => ({
                                name: items[partyDef.PartyName],
                                value: items[partyDef.PartyID],
                            }))
                        ])
                    } else {
                        showErrorToast({
                            message: res1.data.message
                        })
                        setIsLoading(false)
                        return;
                    }

                    const res = await api.get({
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/parties`,
                        params: {
                            [searchParamDef.partyId]: searchParams[searchParamDef.partyId],
                            [searchParamDef.fromDate]: searchParams[searchParamDef.fromDate],
                            [searchParamDef.toDate]: searchParams[searchParamDef.toDate],
                        }
                    });
                    if (res?.data?.success === true) {
                        const employees = res.data.data;

                        const rows = employees.map(
                            (emp, index) => {
                                emp['SerialNo'] = index + 1
                                emp['deleteButton'] = (
                                    <TableStanderd.Button onClick={(event)=>{event.stopPropagation();setDeleteId(emp[partyDef.PartyID]);setShowDeleteModal(true)}} ><IconTrash size={15}/></TableStanderd.Button>
                                )
                                // emp['editButton'] = (
                                //     <TableStanderd.Button><IconPencil size={15}/></TableStanderd.Button>
                                // )
                                return ({
                                    id: emp[partyDef.PartyID],
                                    data: emp
                                })
                            }
                        )
                        setRow1(rows)
                    } else {
                        showErrorToast({
                            message: res?.data?.message || 'something went wrong',
                            showAtTimeOne: true,
                            id: 'partyCRUD',
                            timeOut: 5000
                        })
                    }


                } catch (error) {
                    showErrorToast({
                        message: 'Internal Error !!!',
                        showAtTimeOne: true,
                        id: 'INTERNAL ERROR'
                    })
                }
                setIsLoading(false)
            }

            initialLoad()
            dispatch(setTopNavText('Party'))
            return () => {
                dispatch(setTopNavText(''))
            }

        }, [updateUi]
    )

    const headers = [

        {
            id: '4',
            name: 'No',
            label: 'SerialNo'
        },
        {
            id: '3',
            name: 'Name',
            label: partyDef.PartyName
        },
        {
            id: '1',
            name: 'Address',
            label: partyDef.Address
        },
        {
            id: '2',
            name: 'Mobile',
            label: partyDef.MobileNumber
        },
        {
            id: '5',
            name: 'Email',
            label: partyDef.Email
        },
        {
            id: '6',
            name: '',
            label:'deleteButton'
        },

    ]

    const openDetailsModal = (id, index) => {
        setSelectedEmploye(id)
        setShowDetailsModal(true)
    }

    const theme = useSelector(
        state => state.config.theme
    )

    const onChangeSearchParams = (event) => {
        searchParams[event.target.name] = event.target.value;
        console.log(searchParams)
        setSearchParams({
            ...searchParams
        })
    }

    const elements = [
        { delay: -1600 },
        { delay: -1550 },
        { delay: -1500 },
        { delay: -1450 },
        { delay: -1400 },
        { delay: -1350 },
        { delay: -1300 },
        { delay: -1250 },
        { delay: -1200 },
        { delay: -1150 },
        { delay: -1100 },
        { delay: -1050 },
        { delay: -1000 },
    ];


    return (
        <div className=' grow flex flex-col overflow-hidden'>
            <QuestionModal show={showDeleteModal} Question="Do you want to delete party?" onNegative={() => setShowDeleteModal(false)} onPositive={deleteParty} />
            <div className='flex justify-end gap-2 '>
                <MenuSimple
                    closeInsideTouch={false}
                    show={showFilterModal}
                    closeMenu={() => setShowFilterModal(false)}
                    top={32}
                    right={0}
                    label={<SquareIconButton onClick={() => setShowFilterModal(true)} varient={squareButtonVarient.outlined} icon={<IconFilter />} text={'Filter'} />}
                >
                    <div className=' max-w-60 w-60 flex flex-col py-3'>
                        <div className=' text-sm font-bold flex pb-1 justify-start w-full'>By Date</div>
                        <div className='flex flex-col ps-1'>
                            <InputStd2 title='From' type='date' onChange={onChangeSearchParams} value={searchParams[searchParamDef.fromDate]} name={searchParamDef.fromDate} />
                            <InputStd2 title='To' onChange={onChangeSearchParams} value={searchParams[searchParamDef.toDate]} name={searchParamDef.toDate} type='date' />
                        </div>
                        <div className=' text-sm font-bold flex pb-1 justify-start w-full pt-2'>By Party</div>
                        <div className='ps-1'>
                            <SelectBoxInputBox option={parties} onChange={onChangeSearchParams} value={searchParams[searchParamDef.partyId]} name={searchParamDef.partyId} className={' grow  basis-full sm:basis-auto'} placeholder={'Party'} title={'Party'} />
                        </div>
                        <div className=' w-full flex justify-end pt-2'>
                            <SquareIconButton text={'Search'} onClick={() => { rebuildUi(); setShowFilterModal(false) }} />
                        </div>
                    </div>
                </MenuSimple>
                <SquareIconButton icon={<IconPlus />} text={'Add'} onClick={() => setShowAddModal(true)} />
                <ModalAddBranch show={showAddModal} closeModal={() => setShowAddModal(false)} updateUi={rebuildUi} pushData={(data) => { rows1.push({ id: rows1.length + 1, data }); setRow1([...rows1]) }} />
                <ModalBranchDetails fiscalFull={rows1} id={selectedEmploye} show={showDetailsModal} closeModal={() => setShowDetailsModal(false)} updateUi={rebuildUi} />

            </div>
            <div className='pt-1 pb-5 grow  overflow-hidden flex flex-col gap-2' >
                {isLoading === false ?
                    rows1.length > 0
                        ?
                        <div className=" flex overflow-hidden relative shadow-md sm:rounded-lg">
                            <TableStanderd>
                                <TableStanderd.Head>
                                    {
                                        headers.map(
                                            header => (<th key={header.id} scope="col" className="py-3 px-6">{header.name}</th>)
                                        )
                                    }
                                </TableStanderd.Head>
                                <TableStanderd.Body>
                                    {
                                        rows1.map(
                                            (row, index) => {
                                                if (index === rows1.length - 1) {
                                                    return (
                                                        <TableStanderd.TbRowEnd  onClick={() => openDetailsModal(row.id, index)} key={row.id} >
                                                            {
                                                                headers.map(
                                                                    (header, index) => (
                                                                        <TableStanderd.Td key={index} >{row.data[header.label]}</TableStanderd.Td >
                                                                    )
                                                                )
                                                            }

                                                        </TableStanderd.TbRowEnd>
                                                    )
                                                }

                                                return (
                                                    <TableStanderd.TbRow onClick={() => openDetailsModal(row.id, index)} key={row.id} className={`${theme.state === themeStateDef.PENDING ? 'theme-smooth' : ''} bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-200 hover:dark:bg-gray-600`}>
                                                        {
                                                            headers.map(
                                                                (header, index) => (
                                                                    <TableStanderd.Td key={index} >{row.data[header.label]}</TableStanderd.Td>
                                                                )
                                                            )
                                                        }

                                                    </TableStanderd.TbRow>
                                                )
                                            }
                                        )
                                    }
                                </TableStanderd.Body>
                            </TableStanderd>

                        </div>
                        :
                        <div className=' flex grow dark:text-gray-300 text-3xl font-bold  items-center justify-center theme-smooth'>No Records Found</div>
                    :
                    <div className=' grow flex flex-col gap-2'>


                        {
                            elements.map(
                                (element, index) => (
                                    <div
                                        key={index}
                                        className={`w-full ${index === 0 ? 'h-16' : 'h-11'} bg-gray-600 rounded-md animate-bubblee`}
                                        style={{ animationDelay: `${element.delay}ms` }}
                                    ></div>
                                )
                            )
                        }



                    </div>
                }

            </div>
        </div>
    )
}
